// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Js_string = require("rescript/lib/js/js_string.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var JsxRuntime = require("react/jsx-runtime");
var MobileNumber$ReactHooksTemplate = require("./MobileNumber.res.js");
var SurveyLanguage$ReactHooksTemplate = require("./surveyLanguage.res.js");
var MandatoryMessage$ReactHooksTemplate = require("./MandatoryMessage.res.js");
var QuestionTextPreview$ReactHooksTemplate = require("./QuestionTextPreview.res.js");

function MobileNumberPreview(props) {
  var onChange = props.onChange;
  var language = props.language;
  var mobileNumber = props.mobileNumber;
  var handleOnchange = function ($$event) {
    var value = $$event.target.value;
    var firstChar = value[0];
    var check = Belt_Array.getBy([
          "<",
          "=",
          "+",
          "-",
          "@"
        ], (function (x) {
            return firstChar === x;
          }));
    var validNumber = Js_string.search(/^\d{1,17}$/, value);
    if (check !== undefined || validNumber !== 0 || value.trim() === "") {
      return Curry._1(onChange, MobileNumber$ReactHooksTemplate.setAnswer(mobileNumber, undefined));
    } else {
      return Curry._1(onChange, MobileNumber$ReactHooksTemplate.setAnswer(mobileNumber, value));
    }
  };
  var onTitleChange = function (html) {
    Curry._1(onChange, MobileNumber$ReactHooksTemplate.setText(mobileNumber, html));
  };
  var onDescriptionChange = function (html) {
    Curry._1(onChange, MobileNumber$ReactHooksTemplate.setDescription(mobileNumber, html));
  };
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(QuestionTextPreview$ReactHooksTemplate.make, {
                      text: MobileNumber$ReactHooksTemplate.getTextTranslation(mobileNumber, SurveyLanguage$ReactHooksTemplate.name(language)),
                      description: MobileNumber$ReactHooksTemplate.getDescriptionTranslation(mobileNumber, SurveyLanguage$ReactHooksTemplate.name(language)),
                      onTitleChange: onTitleChange,
                      onDescriptionChange: onDescriptionChange
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: "Input",
                              className: "text-aurometalsaurus text-sm mb-2 font-normal"
                            }),
                        JsxRuntime.jsx("input", {
                              className: "h-48-px py-2 px-4 bg-alicebluepurple border-b border-gray-500 focus:border-gray-600 text-xs w-full",
                              placeholder: MobileNumber$ReactHooksTemplate.getPlaceholderTranslation(mobileNumber, SurveyLanguage$ReactHooksTemplate.name(language)),
                              type: "text",
                              value: MobileNumber$ReactHooksTemplate.answerToString(mobileNumber),
                              onChange: handleOnchange
                            })
                      ]
                    }),
                props.mandatory ? JsxRuntime.jsx(MandatoryMessage$ReactHooksTemplate.make, {
                        language: language
                      }) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
              ],
              className: "w-full p-16"
            });
}

var make = MobileNumberPreview;

exports.make = make;
/* react/jsx-runtime Not a pure module */
